
import Vue from "vue";
import $ from "jquery";
import Component from "vue-class-component";
import AppNavbar1 from "@/components/layout/AppNavbar1.vue";
import AppNavbar2 from "@/components/layout/AppNavbar2.vue";
import { Prop } from "vue-property-decorator";
import AppNavbar3 from "@/components/layout/AppNavbar3.vue";
import AppNavbar4 from "@/components/layout/AppNavbar4.vue";
@Component({
  components: {
    AppNavbar4,
    AppNavbar3,
    AppNavbar2,
    AppNavbar1,
  },
})
export default class AppNavbar extends Vue {
  @Prop({ default: 1 })
  private templateNumber!: number;

  private mobileMenu = false;

  private created() {
    switch (this.templateNumber) {
      case 1:
        $(document).ready(function () {
          $(".nav-container").addClass("bg-navbar");
          $(window).scroll(function () {
            let scroll = $(window).scrollTop() as number;
            if (scroll >= 30) {
              $(".nav-container").removeClass("bg-navbar");
              $(".nav-container").addClass("bg-white");
              $("#nav-brand").removeClass("text-white");
              $(".nav-text").removeClass("text-white");
              $(".burger").addClass("text-black");
              $(".burger").removeClass("text-white");
            } else {
              $(".nav-container").addClass("bg-navbar");
              $(".nav-container").removeClass("bg-white");
              $("#nav-brand").addClass("text-white");
              $(".nav-text").addClass("text-white");
              $(".burger").addClass("text-white");
              $(".burger").removeClass("text-black");
            }
          });
        });
        break;
    }
  }

  private onNavigateJobFair(e: any) {
    e.preventDefault();
    let baseURL = window.location.href;
    if (baseURL.slice(-1) === "/") baseURL = baseURL.slice(0, -1);
    if (baseURL.includes("?")) baseURL = baseURL.split("?")[0];
    window.open(baseURL + "/jobfair");
  }

  private goHome() {
    if (this.$route.name !== "landing") this.$router.push({ name: "landing" });
  }

  private onClick(route: any) {
    if (route === "candidate-register") {
      this.$router.push({ name: "register" });
    } else if (route === "candidate") {
      this.$store.state.app_login = "candidate";
    } else if (route === "company-register") {
      this.$router.push({ name: "partnership" });
    } else if (route === "company") {
      this.$store.state.app_login = "company";
    } else {
      this.$store.state.app_login = "school";
    }
    this.mobileMenu = false;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  private onMoreNews() {
    this.$router.push({
      name: "news",
    });
  }
}
